<div style="background: #ffeeff" class="h-100 overflow-auto">
  <app-sidebar-header (close)="cancel()" [title]="('integration' | translate) + ' RIA'"></app-sidebar-header>
  <mat-card style="" class="shadow-none bg-transparent">
    <mat-card-header class="d-flex flex-column bg-white rounded-2 m-3 p-4">
      <div class="d-flex flex-column bg-white rounded-2">
        <div class="d-flex flex-wrap gap-4">
          <div class="icon-logo">
            <img class="rounded-circle" src="/assets/svgs/integrations/ria_off_color.png" alt="RIA logo" />
          </div>
          <div>
            <h5>{{ 'log_in_with_your_RIA_account' | translate }}</h5>
            <p>{{ 'channel' | translate }}: {{ channel.name }}</p>
            <p>
              {{ 'status' | translate }}:
              <span
                class="badge"
                [ngStyle]="{ 'background-color': $safeNavigationMigration(statuses[channel.status]?.color) }"
              >
                {{
                  statuses[channel.status]?.translate && statuses[channel.status]?.title
                    ? ($safeNavigationMigration(statuses[channel.status]?.title) | translate)
                    : statuses[channel.status]?.title
                }}
              </span>
            </p>
          </div>
        </div>
      </div>
    </mat-card-header>
    <mat-card-content class="d-flex flex-column m-3 gap-3 p-4 bg-white rounded-2">
      <h5>{{ 'information' | translate }}</h5>
      <mat-divider class="mb-3"></mat-divider>
      <div>
        <span>{{ 'api_key' | translate }}</span>
        <app-text-field
          [error]="form.controls.api_key.touched && form.controls.api_key.invalid"
          (focusout)="form.controls.api_key.markAsTouched()"
          [formControl]="form.controls.api_key"
        ></app-text-field>
        @if (form.controls.api_key.touched && form.controls.api_key.invalid) {
          <mat-hint class="text-danger">
            @if (form.controls.api_key.errors?.['required']) {
              {{ 'field_cannot_be_empty' | translate }}
            }
          </mat-hint>
        }
      </div>
      <div>
        <span>{{ 'user_id' | translate }}</span>
        <app-text-field
          [error]="form.controls.user_id.touched && form.controls.user_id.invalid"
          (focusout)="form.controls.user_id.markAsTouched()"
          [formControl]="form.controls.user_id"
        ></app-text-field>
        @if (form.controls.user_id.touched && form.controls.user_id.invalid) {
          <mat-hint class="text-danger">
            @if (form.controls.user_id.errors?.['required']) {
              {{ 'field_cannot_be_empty' | translate }}
            }
          </mat-hint>
        }
      </div>
      <div>
        <span>{{ 'pass_this_indicator_related' | translate }}</span>
        <app-text-field [disabled]="true" [input]="channel.id"></app-text-field>
      </div>
      <div>
        <span>{{ 'pass_this_indicator_webhook' | translate }}</span>
        <app-text-field [disabled]="true" [input]="webhookUrl"></app-text-field>
      </div>
      <div class="d-flex gap-2">
        <div class="flex-fill"></div>
        <app-button [customClass]="'bg-danger'" btnType="cancel" (onChangeClick)="cancel()"
          >{{ 'cancel' | translate }}
        </app-button>
        <app-button [disabled]="form.invalid || !form.dirty" (onChangeClick)="save()">{{
          'save' | translate
        }}</app-button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
